var React = require('react');

function LinkedinInline (props) {
    return React.createElement("svg",props,React.createElement("path",{"fill":"#1A1A29","fillRule":"evenodd","d":"M2.857.362c1.397 0 2.425.894 2.491 2.172 0 1.326-1.048 2.269-2.491 2.269-1.418 0-2.491-.966-2.491-2.243 0-1.273 1.048-2.198 2.49-2.198zM.777 5.697h4.16c.228 0 .415.2.415.445v12.905c0 .245-.187.445-.416.445H.777c-.228 0-.415-.2-.415-.445V6.142c0-.245.187-.445.415-.445zm6.239 0h4.158c.23 0 .416.2.416.445v.663c.67-.503 1.776-1.108 3.24-1.108 3.219 0 4.662 2.906 4.662 5.785v7.565c0 .245-.187.445-.416.445h-3.743c-.23 0-.416-.2-.416-.445V12.15c0-1.055-.757-1.914-1.722-1.994-.05-.01-.1-.009-.15-.009-.049 0-.099 0-.149.009-.964.08-1.722.939-1.722 1.994v6.897c0 .246-.186.445-.415.445H7.016c-.23 0-.416-.2-.416-.445V6.142c0-.245.187-.445.416-.445z","opacity":".3"}));
}

LinkedinInline.defaultProps = {"width":"20","height":"20","viewBox":"0 0 20 20"};

module.exports = LinkedinInline;

LinkedinInline.default = LinkedinInline;
